(() => {
  if (customElements.get('drbo-osda-pack-offer')) return;
  customElements.define('drbo-osda-pack-offer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.button = this.querySelector('button');
      this.status = this.querySelector('[data-offer-status]');
      this.total = this.querySelector('[data-offer-total]');
      this.count = this.querySelector('[data-offer-count]');
      this.action = this.button.textContent;
      const signal = this.controller.signal;
      this.button.addEventListener('click', () => this.selectPack(), { signal });
      this.root = this.closest('.shopify-section');
      if (!this.root) return;
      this.root.addEventListener('input', () => this.update(), { signal });
      this.root.addEventListener('change', () => this.update(), { signal });
      this.root.addEventListener('click', () => requestAnimationFrame(() => this.isConnected && this.update()), { signal });
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    get input() {
      return Array.from(this.root?.querySelectorAll('input[name="quantity"]') || [])
        .find(input => input.getAttribute('form') === this.dataset.formId);
    }
    eligible() {
      const min = Number(this.dataset.min) || 1;
      const step = Number(this.dataset.step) || 1;
      const max = this.dataset.max ? Number(this.dataset.max) : Infinity;
      const stock = this.dataset.stock ? Number(this.dataset.stock) : Infinity;
      const variant = document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value;
      return !!this.input && this.dataset.available === 'true' && min <= 4 && max >= 4 && stock >= 4 &&
        (4 - min) % step === 0 && (!variant || variant === this.dataset.variantId);
    }
    update() {
      const eligible = this.eligible();
      const quantity = Number(this.input?.value);
      const selected = eligible && Number.isInteger(quantity) && quantity >= 4;
      const displayQuantity = selected ? quantity : 4;
      this.total.textContent = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(displayQuantity * 100);
      this.count.textContent = 'Gesamt f\u00fcr ' + displayQuantity + ' Module';
      this.button.disabled = !eligible || selected;
      this.button.hidden = selected;
      this.dataset.qualifying = String(selected);
      this.status.textContent = !eligible ? '4er-Auswahl derzeit nicht verf\u00fcgbar' :
        selected ? quantity + ' Module ausgew\u00e4hlt' : this.action;
    }
    selectPack() {
      if (!this.eligible()) return;
      if (Number(this.input.value) >= 4) return;
      this.input.value = '4';
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.update();
    }
  });
})();
